"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _color = require("../../helpers/color");

var _space = require("../../helpers/space");

var _Collapse = require("../Collapse");

var _Flex = require("../Flex");

var _Spacer = require("../Spacer");

var _Typography = require("../Typography/Typography");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledTextArea = _styledComponents.default.textarea.withConfig({
  displayName: "TextArea__StyledTextArea",
  componentId: "tnq35k-0"
})(["transition:border-color 0.25s ease;padding:", "px;min-height:", "px;font-family:", ";font-size:", "px;line-height:", "px;outline:none;", ";resize:vertical;"], (0, _space.space)(1), (0, _space.space)(9), (0, _styledSystem.themeGet)("fontFamily.sans.regular"), (0, _styledSystem.themeGet)("typeSizes.sans.3.fontSize"), (0, _styledSystem.themeGet)("typeSizes.sans.3.lineHeight"), function (_ref) {
  var hasError = _ref.hasError;
  return (0, _styledComponents.css)(["border:1px solid ", ";:active,:focus{border-color:", ";}"], (0, _color.color)(hasError ? "red100" : "black10"), (0, _color.color)(hasError ? "red100" : "purple100"));
});

var Required = _styledComponents.default.span.withConfig({
  displayName: "TextArea__Required",
  componentId: "tnq35k-1"
})(["color:", ";"], (0, _color.color)("purple100"));

/** TextArea */
var TextArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextArea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.defaultValue || ""
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (ev) {
      _this.handleTextChange(ev.currentTarget.value);
    });

    return _this;
  }

  _createClass(TextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var defaultValue = this.props.defaultValue;

      if (defaultValue) {
        this.handleTextChange(defaultValue);
      }
    }
  }, {
    key: "handleTextChange",
    value: function handleTextChange(nextValue) {
      var _this2 = this;

      this.setState({
        value: nextValue
      }, function () {
        var onChange = _this2.props.onChange;
        var value = _this2.state.value;
        onChange && onChange({
          value: value,
          exceedsCharacterLimit: _this2.characterLimitExceeded()
        });
      });
    }
  }, {
    key: "characterLimitExceeded",
    value: function characterLimitExceeded() {
      var characterLimit = this.props.characterLimit;
      var value = this.state.value;
      return Boolean(characterLimit && value.length > characterLimit);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          characterLimit = _this$props.characterLimit,
          title = _this$props.title,
          description = _this$props.description,
          others = _objectWithoutProperties(_this$props, ["error", "characterLimit", "title", "description"]);

      var value = this.state.value;
      var hasError = Boolean(error || this.characterLimitExceeded());
      return _react.default.createElement(_Flex.Flex, {
        flexDirection: "column"
      }, title && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Typography.Sans, {
        size: "3t"
      }, title, this.props.required && _react.default.createElement(Required, null, "*"))), description && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Typography.Sans, {
        size: "2",
        color: "black60"
      }, description)), (title || description) && _react.default.createElement(_Spacer.Spacer, {
        mb: 1
      }), _react.default.createElement(StyledTextArea, _extends({}, others, {
        onChange: this.onChange,
        hasError: hasError
      })), _react.default.createElement(_Spacer.Spacer, {
        mb: 1
      }), _react.default.createElement(_Flex.Flex, {
        justifyContent: "space-between"
      }, _react.default.createElement(_Collapse.Collapse, {
        open: Boolean(error)
      }, _react.default.createElement(_Typography.Sans, {
        color: "red100",
        size: "2"
      }, error)), _react.default.createElement(_Flex.Flex, null), typeof characterLimit !== "undefined" && _react.default.createElement(_Typography.Sans, {
        size: "2",
        color: this.characterLimitExceeded() ? "red100" : "black60"
      }, value.length, " / ", characterLimit, " max")));
    }
  }]);

  return TextArea;
}(_react.default.Component);

exports.TextArea = TextArea;
TextArea.displayName = "TextArea";
//# sourceMappingURL=TextArea.js.map